import { render } from "./tech.vue?vue&type=template&id=1a8925f6&scoped=true"
const script = {}

import "./tech.vue?vue&type=style&index=0&id=1a8925f6&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8925f6"]])

export default __exports__